import { render, staticRenderFns } from "./PurchaseDetailList.vue?vue&type=template&id=3af68a74&scoped=true&"
import script from "./PurchaseDetailList.vue?vue&type=script&lang=js&"
export * from "./PurchaseDetailList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseDetailList.vue?vue&type=style&index=0&id=3af68a74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af68a74",
  null
  
)

export default component.exports